import { IgxGridComponent } from '@infragistics/igniteui-angular/grids/grid';
import {ClsUtil} from '../../../util/cls-util';
import {EnumExpInsumos} from '../../../core/models/enum/enum-exp-insumos';
import {INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {EnumMCExpInsumos, EnumMCGenerales} from '../../../core/models/enum/enum-menu-contextual';
import {GenericoService} from '../../../core/services/generico.service';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../../core/services/app-info.service';
import {
  DmSecundarioComponent
} from '../../../componentes/00-contenedores/docker-manager/dmseundario/dm-secundario.component';
import {ClsConfig} from '../../../util/cls-config';
import {
  ClsPeticionBorrarExpIns,
  ClsPeticionGuardarActualizarExpIns,
  ClsPeticionObtieneExpXConcepto,
  ClsRespuestaBorrarExpIns,
  ClsRespuestaGuardarActualizarExpIns
} from '../../../core/models/peticiones/cls-pr-catalogo-general';
import {
  ClsPeticionExpinsXconcepto,
  ClsPeticionExpinsXconceptoXProyecto
} from '../../../core/models/peticiones/cls-pr-calculo';
import {EnumParaOrg} from '../../../core/models/enum/enum-parametros';
import {ClsObjGenerico} from '../../util/cls-obj-generico';
import {ComponenteHostDirective} from '../../../componentes/00-contenedores/docker-manager/dock-slot.component';
import {VtnGenericaComponent} from '../../../componentes/util/ventanas/vtn-generica/vtn-generica.component';
import {
  ExpInsumosPorConceptoComponent
} from '../../../componentes/util/ventanas/exp-insumos-por-concepto/exp-insumos-por-concepto.component';
import {ClsBorrarRegistro, ClsCatalogosExpIns, ClsCatalogosExpIns2} from "../../../core/models/cls-catalogo-general";
import {ClsCalculoDetalleExpXConcepto, ClsCalculoDetalleExpXConceptoProyecto} from "../../../core/models/cls-calculo";
import {ClsParametro} from "../../../core/models/cls-parametros";
import {ClsGuardarConceptosPartidaDetalle} from "../../../core/models/cls-concepto";
import {ClsGuardarMatrizDetalle} from "../../../core/models/cls-matriz";
import {inject} from "@angular/core";
import {EnumMasOpciones} from "../../../core/models/enum/enum-mas-opciones";
import {CrearComponenteDinamicoService} from "../../../core/services/crear-componente-dinamico.service";
import {ClsPeticionPresupuestos} from "../../../core/models/peticiones/cls-pr-generico";

export class ClsObjExplosionDeInsumos extends ClsConfig {
  public gridExpInsumos: IgxGridComponent;
  // arreglos para filtrado
  public gridDataCompleta: ClsCatalogosExpIns[] = [];
  private gridDataFiltrada: ClsCatalogosExpIns[] = [];
  public dataExpInsumo: ClsCatalogosExpIns[] = [];
  // menu contextual
  private menus: INeodataMenu[] = [];
  private infPpto = inject(AppPresupuestosService);
  private servicioGen = inject(GenericoService);
  private infApp = inject(AppInfoService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);
  constructor() {
    super();
  }

  public async registraActualizaRegistro(registro: ClsCatalogosExpIns2[]): Promise<any> {
    let respuesta: any;
    const objPeticion: ClsPeticionGuardarActualizarExpIns =  new ClsPeticionGuardarActualizarExpIns();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion =  this.infPpto.organizacion.IdOrganizacion;
    objPeticion.Catalogo = registro;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'CatalogoRegistraActualizaCod');
      // modo offline
      if (!respuesta) {
        return;
      }
      const resp: ClsRespuestaGuardarActualizarExpIns = ClsUtil.parseJSONBig(respuesta);
      if (resp?.Errores?.ErrorDescripcion !== '') {
        throw new Error(resp.Errores.ErrorDescripcion);
      }
      return resp.ListaIdsCodigo;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async borrarRegistro(ids: bigint[], validar: boolean): Promise<ClsBorrarRegistro[]> {
    let respuesta: ClsBorrarRegistro[];
    const objPeticion: ClsPeticionBorrarExpIns = new ClsPeticionBorrarExpIns();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion =  this.infPpto.organizacion.IdOrganizacion;
    objPeticion.Validar = validar;
    objPeticion.ListaIds = ids;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'EliminarInsumoCatalogo');
      // modo offline
      if (!respuesta) {
        return [];
      }
      const resp: ClsRespuestaBorrarExpIns = ClsUtil.parseJSONBig(respuesta);
      if (resp?.Errores?.ErrorDescripcion !== '') {
        throw new Error(resp.Errores.ErrorDescripcion);
      }
      return resp.Codigo ?? []; // si es null/undefined devuelve []
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtieneExpXConceptos(id: bigint): Promise<ClsCalculoDetalleExpXConcepto[]> {
    let respuesta: ClsCalculoDetalleExpXConcepto[];
    const objPeticion: ClsPeticionObtieneExpXConcepto = new ClsPeticionObtieneExpXConcepto();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion =  this.infPpto.organizacion.IdOrganizacion;
    objPeticion.IdCodigoMatriz = id;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtieneCalculaExpinsXconcepto');
      // modo offline
      if (!respuesta) {
        return [];
      }
      const resp: ClsPeticionExpinsXconcepto = ClsUtil.parseJSONBig(respuesta);
      if (resp?.Errores?.ErrorDescripcion !== '') {
        throw new Error(resp.Errores.ErrorDescripcion);
      }
      return resp.JsonExpinsXconcepto ?? [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async obtieneExpXConceptosXProyecto(): Promise< ClsCalculoDetalleExpXConceptoProyecto[]> {
    let respuesta:  ClsCalculoDetalleExpXConceptoProyecto[];
    const objPeticion: ClsPeticionPresupuestos = new ClsPeticionPresupuestos();
    objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
    objPeticion.IdPresupuesto = this.infPpto.pptoSeleccionadoActivo.IdPresupuesto;
    objPeticion.IdOrganizacion =  this.infPpto.organizacion.IdOrganizacion;
    try {
      respuesta = await this.servicioGen.enviarPeticionCloudRunSistema(objPeticion, 'ObtieneExpinsXconceptoXProyecto');
      // modo offline
      if (!respuesta) {
        return [];
      }
      const resp: ClsPeticionExpinsXconceptoXProyecto = ClsUtil.parseJSONBig(respuesta);
      if (resp?.Errores?.ErrorDescripcion !== '') {
        throw new Error(resp.Errores.ErrorDescripcion);
      }
      return resp.ExpinsXconcepto ?? [];
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public compararSiCambioAnyCampos(newValor: ClsCatalogosExpIns, oldValor: ClsCatalogosExpIns): boolean {
    let cambio = false;
    // si oldValor es esNulo quiere decir que es nuevo, se ocupa para CH
    if (ClsUtil.esNulo(oldValor)) {
      return true;
    }

    // Definir los campos a comparar
    const campos = ['Marca', 'Nivel', 'Codigo', 'DescripcionLarga', 'Descripcion', 'Unidad',
                            'Tipo', 'CostoMoneda1', 'CostoMoneda2', 'Expins', 'ImporteMoneda1', 'ImporteMoneda2',
                            'Familia', 'DescripcionFamilia', 'Proveedor', 'RazonSocial', 'InsumoIntegrado', 'FechaMoneda1',
                            'FechaMoneda2', 'EsCostoHorario', 'PendienteAnalizar', 'ExpInsl', 'EsConceptosDelPpto', 'EsPorcentaje',
                            'Participa', 'TipoPorcentaje', 'Referencia', 'UrlContenido'];
    // Comparar cada campo
    for (const campo of campos) {
      if (campo === 'FechaMoneda1' || campo === 'FechaMoneda2') {
        if (ClsUtil.cadenaX(newValor[campo]) !== ClsUtil.cadenaX(oldValor[campo])) {
          return true;
        }
      } else {
        if (newValor[campo] !== oldValor[campo]) {
          return true;
        }
      }
    }

    // Si no hubo cambios, retornar false
    return false;
  }

  // public inicializarComponenteComoMaestro(component: GridExplosionDeInsumosComponent, maestro: boolean) {
  //   if (maestro) {
  //     component.masOpcionesG.arrayDatosAVer = [0, 5];
  //     component.masOpcionesG.filtrarDatosAVer();
  //   } else {
  //     component.masOpcionesG.arrayDatosAVer = [0, 1, 5];
  //     component.masOpcionesG.filtrarDatosAVer();
  //   }
  // }

  public buscarCodigoEnExpIns(codigo: string): ClsCatalogosExpIns {
    let catalogo: ClsCatalogosExpIns;
    if (!ClsUtil.esNulo(codigo)) {
      if (this.infPpto.esPptoMaestro) {
        catalogo = this.buscarEnMastroYModificarValores(codigo)
      } else {
        catalogo = this.existeCodigoExpIns(codigo);
        // si no existe en catalogo del ppto, buscar en el maestro si esta activo
        if (ClsUtil.esNulo(catalogo) && !ClsUtil.esNulo(this.infPpto.pptoMaestroCompletoJSON.CatExpIns)) {
          catalogo = this.buscarEnMastroYModificarValores(codigo);
        } else {
          catalogo.DesdeMaestro = false;
        }
      }
    }
    return catalogo;
  }

  public buscarIdCatalogoEnExpIns(idCatalogo: bigint): ClsCatalogosExpIns {
    return this.infPpto.pptoActivoCompletoJSON.CatExpIns.find(value =>  value.IdCatalogo === idCatalogo);
  }

  private buscarEnMastroYModificarValores(codigo: string): ClsCatalogosExpIns {
    let catalogo: ClsCatalogosExpIns;
    catalogo = this.infPpto.pptoMaestroCompletoJSON.CatExpIns.find(e => e.Codigo.toUpperCase() === codigo.toUpperCase());
    if (!ClsUtil.esNulo(catalogo)) {
      catalogo.DesdeMaestro = true;
      catalogo.Nivel = 0;
      catalogo.Expins = 0;
      catalogo.ImporteMoneda1 = ClsUtil.redondearMoneda(catalogo.CostoMoneda1 * catalogo.Expins, this.infPpto.decimalredondearimporte);
      catalogo.ImporteMoneda2 = ClsUtil.redondearMoneda(catalogo.CostoMoneda2 * catalogo.Expins, this.infPpto.decimalredondearimporte);
    }
    return catalogo;
  }

  public inicializarAsignarRegistro(data: ClsCatalogosExpIns | undefined): ClsCatalogosExpIns {
    const fecha = new Date();
    const catalogo: ClsCatalogosExpIns = new ClsCatalogosExpIns();
    catalogo.IdCatalogo = ClsUtil.esNulo(data) ? BigInt('0') : data.IdCatalogo;
    // catalogo.IdCatalogoS = ClsUtil.esNulo(data) ? '' : data.IdCatalogoS;
    catalogo.Codigo = ClsUtil.esNulo(data) ? '' : data.Codigo;
    catalogo.DescripcionLarga = ClsUtil.esNulo(data) ? 'Código nuevo' : data.DescripcionLarga;
    catalogo.Descripcion = ClsUtil.esNulo(data) ? 'Código nuevo' : data.Descripcion;
    catalogo.CantidadACopiar = ClsUtil.esNulo(data) ? '' : data.CantidadACopiar.toString();
    catalogo.Unidad = ClsUtil.esNulo(data) ? 'UNIDAD' : data.Unidad;
    catalogo.Tipo = ClsUtil.esNulo(data) ? 1 : data.Tipo;
    catalogo.CostoMoneda1 = ClsUtil.esNulo(data) ? 0 : data.CostoMoneda1;
    catalogo.CostoMoneda2 = ClsUtil.esNulo(data) ? 0 : data.CostoMoneda2;
    catalogo.Expins = ClsUtil.esNulo(data) ? 1 : data.Expins;
    catalogo.ImporteMoneda1 = ClsUtil.esNulo(data) ? 0 : data.ImporteMoneda1;
    catalogo.ImporteMoneda2 = ClsUtil.esNulo(data) ? 0 : data.ImporteMoneda2;
    catalogo.Familia = ClsUtil.esNulo(data) ? '' : data.Familia;
    catalogo.Nivel = ClsUtil.esNulo(data) ? 0 : data.Nivel;
    catalogo.ExpInsl = ClsUtil.esNulo(data) ? false : data.ExpInsl;
    catalogo.EsConceptosDelPpto = ClsUtil.esNulo(data) ? false : data.EsConceptosDelPpto;
    catalogo.DescripcionFamilia = ClsUtil.esNulo(data) ? '' : data.DescripcionFamilia;
    catalogo.Proveedor = ClsUtil.esNulo(data) ? '' : data.Proveedor;
    catalogo.RazonSocial = ClsUtil.esNulo(data) ? '' : data.RazonSocial;
    catalogo.InsumoIntegrado = ClsUtil.esNulo(data) ? false : data.InsumoIntegrado;
    catalogo.FechaMoneda1 = ClsUtil.esNulo(data) ? new Date(fecha.getUTCFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours(), fecha.getMinutes(), fecha.getSeconds(), fecha.getMilliseconds()) : data.FechaMoneda1;
    catalogo.FechaMoneda2 = ClsUtil.esNulo(data) ? new Date(fecha.getUTCFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours(), fecha.getMinutes(), fecha.getSeconds(), fecha.getMilliseconds()) : data.FechaMoneda2;
    catalogo.EsCostoHorario = ClsUtil.esNulo(data) ? false : data.EsCostoHorario;
    catalogo.PendienteAnalizar = ClsUtil.esNulo(data) ? false : data.PendienteAnalizar;
    catalogo.EsPorcentaje = ClsUtil.esNulo(data) ? false : data.EsPorcentaje;
    catalogo.Participa = ClsUtil.esNulo(data) ? false : data.Participa;
    catalogo.TipoPorcentaje = ClsUtil.esNulo(data) ? 0 : data.TipoPorcentaje;
    catalogo.Url = ClsUtil.esNulo(data) ? '' : data.Url;
    catalogo.UrlContenido = ClsUtil.esNulo(data) ? '' : data.UrlContenido;
    catalogo.ArrIdsMatriz = ClsUtil.esNulo(data) ? [] : data.ArrIdsMatriz;
    catalogo.ArrIdsPartida = ClsUtil.esNulo(data) ? [] : data.ArrIdsPartida;
    return catalogo;
  }

  public inicializarAsignarRegistroUnirPpto(data: any): ClsCatalogosExpIns {
    const fecha = new Date();
    const catalogo: ClsCatalogosExpIns = new ClsCatalogosExpIns();
    catalogo.IdCatalogo = ClsUtil.esNulo(data) ? BigInt('0') : data.IdCatalogo;
    // catalogo.IdCatalogoS = ClsUtil.esNulo(data) ? '' : data.IdCatalogoS;
    catalogo.Codigo = ClsUtil.esNulo(data.Codigo) ? '' : data.Codigo;
    catalogo.DescripcionLarga = ClsUtil.esNulo(data.DescripcionCompleta) ? 'Código nuevo' : data.DescripcionCompleta;
    catalogo.Descripcion = ClsUtil.esNulo(data.DescripcionCompleta) ? 'Código nuevo' : data.DescripcionCompleta;
    catalogo.CantidadACopiar = '';
    catalogo.Unidad = ClsUtil.esNulo(data.Unidad) ? 'UNIDAD' : data.Unidad;
    catalogo.Tipo = ClsUtil.esNulo(data.Tipo) ? 1 : data.Tipo;
    catalogo.CostoMoneda1 = ClsUtil.esNulo(data.CostoMoneda1) ? 0 : data.CostoMoneda1;
    catalogo.CostoMoneda2 = ClsUtil.esNulo(data.CostoMoneda2) ? 0 : data.CostoMoneda2;
    catalogo.Expins = ClsUtil.esNulo(data.Expins) ? 1 : data.Expins;
    catalogo.ImporteMoneda1 = ClsUtil.esNulo(data.ImporteMoneda1) ? 0 : data.ImporteMoneda1;
    catalogo.ImporteMoneda2 = ClsUtil.esNulo(data.ImporteMoneda2) ? 0 : data.ImporteMoneda2;
    catalogo.Familia = ClsUtil.esNulo(data.Familia) ? '' : data.Familia;
    catalogo.Nivel = ClsUtil.esNulo(data.Nivel) ? 0 : data.Nivel;
    catalogo.ExpInsl = ClsUtil.esNulo(data.ExpInsl) ? false : data.ExpInsl;
    catalogo.EsConceptosDelPpto = ClsUtil.esNulo(data.EsConceptosDelPpto) ? false : data.EsConceptosDelPpto;
    catalogo.DescripcionFamilia = ClsUtil.esNulo(data.DescripcionFamilia) ? '' : data.DescripcionFamilia;
    catalogo.Proveedor = ClsUtil.esNulo(data.Proveedor) ? '' : data.Proveedor;
    catalogo.RazonSocial = ClsUtil.esNulo(data.RazonSocial) ? '' : data.RazonSocial;
    catalogo.InsumoIntegrado = ClsUtil.esNulo(data.InsumoIntegrado) ? false : data.InsumoIntegrado;
    catalogo.FechaMoneda1 = ClsUtil.esNulo(data.FechaMoneda1) ? new Date(fecha.getUTCFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours(), fecha.getMinutes(), fecha.getSeconds(), fecha.getMilliseconds()) : data.FechaMoneda1;
    catalogo.FechaMoneda2 = ClsUtil.esNulo(data.FechaMoneda2) ? new Date(fecha.getUTCFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours(), fecha.getMinutes(), fecha.getSeconds(), fecha.getMilliseconds()) : data.FechaMoneda2;
    catalogo.EsCostoHorario = ClsUtil.esNulo(data.EsCostoHorario) ? false : data.EsCostoHorario;
    catalogo.PendienteAnalizar = ClsUtil.esNulo(data.PendienteAnalizar) ? false : data.PendienteAnalizar;
    catalogo.EsPorcentaje = ClsUtil.esNulo(data.EsPorcentaje) ? false : data.EsPorcentaje;
    catalogo.Participa = ClsUtil.esNulo(data.Participa) ? false : data.Participa;
    catalogo.TipoPorcentaje = ClsUtil.esNulo(data.TipoPorcentaje) ? 0 : data.TipoPorcentaje;
    catalogo.UrlContenido = ClsUtil.esNulo(data.UrlContenido) ? '' : data.UrlContenido;
    catalogo.ArrIdsMatriz = ClsUtil.esNulo(data.ArrIdsMatriz) ? [] : data.ArrIdsMatriz;
    catalogo.ArrIdsPartida = ClsUtil.esNulo(data.ArrIdsPartida) ? [] : data.ArrIdsPartida;
    return catalogo;
  }

  public inicializarRegistroServicio(data: ClsCatalogosExpIns[], isAddRow: boolean): ClsCatalogosExpIns2[] {
    const resp: ClsCatalogosExpIns2[] = [];
    data.forEach(data2 => {
      const catalogo: ClsCatalogosExpIns2 = new ClsCatalogosExpIns2();
      catalogo.IdCatalogo = (isAddRow && data2.IdCatalogo === BigInt('0')) ? BigInt('0') : data2.IdCatalogo;
      catalogo.IdCodigoSql = BigInt('0');
      catalogo.Codigo = data2.Codigo;
      catalogo.Descripcion = data2.Descripcion;
      catalogo.DescripcionLarga = data2.DescripcionLarga;
      catalogo.EsPorcentaje = Number(data2.TipoPorcentaje);
      catalogo.Familia = data2.Familia;
      // catalogo.IdFamilia = data2.IdFamilia;
      // catalogo.IdProveedor = data2.IdProveedor;
      catalogo.Proveedor = data2.Proveedor;
      catalogo.TipoInsumo = data2.Tipo;
      catalogo.Unidad = data2.Unidad;
      catalogo.Referencia = isAddRow ? '' : data2.Referencia;
      catalogo.EsCostoHorario = data2.EsCostoHorario;
      catalogo.EsConceptosDelPpto = data2.EsConceptosDelPpto;
      catalogo.Expins = data2.Expins;
      catalogo.ExpInsl = data2.ExpInsl;
      catalogo.InsumoIntegrado = data2.InsumoIntegrado;
      catalogo.Marca = isAddRow ? false : data2.Marca;
      catalogo.Nivel = data2.Nivel;
      catalogo.Participa = data2.Participa;
      catalogo.PendienteAnalizar = data2.PendienteAnalizar;
      catalogo.ObservacionPendiente = isAddRow ? '' : data2.ObservacionPendiente;
      catalogo.CostoMoneda1 = data2.CostoMoneda1;
      catalogo.FechaMoneda1 = data2.FechaMoneda1;
      catalogo.CostoMoneda2 = data2.CostoMoneda2;
      catalogo.FechaMoneda2 = data2.FechaMoneda2;
      catalogo.UrlContenido = data2.UrlContenido;
      catalogo.ArrIdsMatriz = isAddRow ? [] : data2.ArrIdsMatriz;
      catalogo.ArrIdsPartida =  isAddRow ? [] : data2.ArrIdsPartida;
      resp.push(catalogo);
    });

    return resp;
  }
  public inicializarRegistroServicioMat(data: ClsCatalogosExpIns[]): ClsCatalogosExpIns2[] {
    const fecha = new Date();
    const resp: ClsCatalogosExpIns2[] = [];
    data.forEach(data2 => {
      const catalogo: ClsCatalogosExpIns2 = new ClsCatalogosExpIns2();
      catalogo.IdCatalogo = data2.IdCatalogo;
      catalogo.IdCodigoSql = BigInt('0');
      catalogo.Codigo = data2.Codigo;
      catalogo.Descripcion = data2.Descripcion;
      catalogo.DescripcionLarga = data2.DescripcionLarga;
      catalogo.EsPorcentaje = Number(data2.TipoPorcentaje);
      catalogo.Familia = data2.Familia;
      // catalogo.IdFamilia = data2.IdFamilia;
      // catalogo.IdProveedor = data2.IdProveedor;
      catalogo.Proveedor = data2.Proveedor;
      catalogo.TipoInsumo = Number(data2.Tipo);
      catalogo.Unidad = data2.Unidad;
      catalogo.Referencia = data2.Referencia ? data2.Referencia : '';
      catalogo.EsCostoHorario = data2.EsCostoHorario;
      catalogo.EsConceptosDelPpto = data2.EsConceptosDelPpto;
      catalogo.Expins = data2.Expins;
      catalogo.ExpInsl = data2.ExpInsl;
      catalogo.InsumoIntegrado = data2.InsumoIntegrado;
      catalogo.Marca = data2.Marca ? data2.Marca : false;
      catalogo.Nivel = data2.Nivel;
      catalogo.Participa = data2.Participa;
      catalogo.PendienteAnalizar = data2.PendienteAnalizar;
      catalogo.ObservacionPendiente = data2.ObservacionPendiente ? data2.ObservacionPendiente : '';
      catalogo.CostoMoneda1 = data2.CostoMoneda1;
      catalogo.FechaMoneda1 = data2.FechaMoneda1 ? data2.FechaMoneda1 : new Date(fecha.getUTCFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours(), fecha.getMinutes(), fecha.getSeconds(), fecha.getMilliseconds());
      catalogo.CostoMoneda2 = data2.CostoMoneda2;
      catalogo.FechaMoneda2 = data2.FechaMoneda2 ? data2.FechaMoneda2 : new Date(fecha.getUTCFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours(), fecha.getMinutes(), fecha.getSeconds(), fecha.getMilliseconds());
      catalogo.UrlContenido = data2.UrlContenido;
      catalogo.ArrIdsMatriz = [];
      catalogo.ArrIdsPartida = [];
      resp.push(catalogo);
    });

    return resp;
  }

  public crearRegistrosEQ(registro: ClsCatalogosExpIns, paramUnidades: ClsParametro[]): ClsCatalogosExpIns[] {
    const arrayEqs: ClsCatalogosExpIns[] = [];
    const codigo: string = registro.Codigo;
    for (let i = 1; i <= 4; i++) {
      const EQs: ClsCatalogosExpIns = this.inicializarAsignarRegistro(registro);
      EQs.IdCatalogo = BigInt('0');
      EQs.EsCostoHorario = false;
      switch (i) {
        case 1:
          // validamos si el codigo de CH inicia con EQ para quitarlo
          const codAux: string = codigo.startsWith('EQ') ? codigo.substring(2, codigo.length) : codigo;
          EQs.Codigo = `CF${codAux}`;
          break;
        case 2:
          EQs.Codigo = `${codigo}-E`;
          EQs.Unidad = paramUnidades.find(para => para.Parametro === EnumParaOrg.UNIINSESPRES).Valor;
          break;
        case 3:
          EQs.Codigo = `${codigo}-R`;
          EQs.Unidad = paramUnidades.find(para => para.Parametro === EnumParaOrg.UNIINSESPRES).Valor;
          break;
        case 4:
          EQs.Codigo = `VA${codigo}`;
          EQs.Unidad = paramUnidades.find(para => para.Parametro === EnumParaOrg.UNIVALORADQEQ).Valor;
          break;
      }
      arrayEqs.push(EQs);
    }
    return arrayEqs;
  }

  /**
   * Metodo que regresa el index o posicion del registro de la lista del ppto activo
   * @param codigo valor a buscar
   */
  public existeCodigoExpInsIndex(codigo: string): number {
    return this.infPpto.pptoActivoCompletoJSON.CatExpIns.findIndex(insumo => insumo.Codigo.toUpperCase() === codigo.toUpperCase());
  }

  /**
   * Metodo que regresa el registro de la lista del ppto activo
   * @param codigo valor a buscar
   */
  public existeCodigoExpIns(codigo: string): ClsCatalogosExpIns {
    return this.infPpto.pptoActivoCompletoJSON.CatExpIns.find(insumo => insumo.Codigo.toUpperCase() === codigo.toUpperCase());
  }

  public updateCell(catalogo: ClsCatalogosExpIns, rowId: number) {
    // this.gridExpInsumos.updateCell(catalogo.IdCatalogo, rowId, 'IdCatalogo');
    // Definir los campos a actualizar y sus correspondientes nombres en la cuadrícula
    const campos = [
      { valor: catalogo.Nivel, clave: 'Nivel' },
      { valor: catalogo.Codigo, clave: 'Codigo' },
      { valor: catalogo.DescripcionLarga, clave: 'DescripcionLarga' },
      { valor: catalogo.Descripcion, clave: 'Descripcion' },
      { valor: catalogo.CantidadACopiar, clave: 'CantidadACopiar' },
      { valor: catalogo.Unidad, clave: 'Unidad' },
      { valor: catalogo.Tipo, clave: 'Tipo' },
      { valor: catalogo.CostoMoneda1, clave: 'CostoMoneda1' },
      { valor: catalogo.CostoMoneda2, clave: 'CostoMoneda2' },
      { valor: catalogo.Expins, clave: 'Expins' },
      { valor: catalogo.ImporteMoneda1, clave: 'ImporteMoneda1' },
      { valor: catalogo.ImporteMoneda2, clave: 'ImporteMoneda2' },
      { valor: catalogo.Familia, clave: 'Familia' },
      { valor: catalogo.DescripcionFamilia, clave: 'DescripcionFamilia' },
      { valor: catalogo.Proveedor, clave: 'Proveedor' },
      { valor: catalogo.RazonSocial, clave: 'RazonSocial' },
      { valor: catalogo.InsumoIntegrado, clave: 'InsumoIntegrado' },
      { valor: catalogo.FechaMoneda1, clave: 'FechaMoneda1' },
      { valor: catalogo.FechaMoneda2, clave: 'FechaMoneda2' },
      { valor: catalogo.EsCostoHorario, clave: 'EsCostoHorario' },
      { valor: catalogo.PendienteAnalizar, clave: 'PendienteAnalizar' },
      { valor: catalogo.ExpInsl, clave: 'ExpInsl' },
      { valor: catalogo.EsConceptosDelPpto, clave: 'EsConceptosDelPpto' },
      { valor: catalogo.EsPorcentaje, clave: 'EsPorcentaje' },
      { valor: catalogo.Participa, clave: 'Participa' },
      { valor: catalogo.TipoPorcentaje, clave: 'TipoPorcentaje' },
      { valor: catalogo.UrlContenido, clave: 'UrlContenido' }
    ];

    // Actualizar las celdas en la cuadrícula
    campos.forEach(campo => {
      this.gridExpInsumos.updateCell(campo.valor, rowId, campo.clave);
    });
  }

  /**
   * Este metodo descomprime catalogo: ClsUtil.descomprimirArchivoBase64(catalogoZip.Catalogo, 'Catalogo.txt');
   * @param catalogoZip recibe la data de catalogo
   */
  public async crearObjCatalogos(catalogoZip: string): Promise<ClsCatalogosExpIns[]> {
    const catalogos: ClsCatalogosExpIns[] = [];
    try {
      const contenido: string = await ClsUtil.descomprimirArchivoBase64(catalogoZip, 'Catalogo.txt');
      if (ClsUtil.esNulo(contenido)) {
        return catalogos;
      }
      const objCatalogo: string[] = ClsUtil.splitEnterNeo(contenido);
      objCatalogo.forEach(data => {
        const catalogo: ClsCatalogosExpIns = new ClsCatalogosExpIns();
        const filas: string[] = ClsUtil.splitTabsNeo(data);
        catalogo.IdCatalogo = ClsUtil.bigintX(filas[0]);
        catalogo.Codigo = ClsUtil.cadenaX(filas[1]);
        catalogo.DescripcionLarga = ClsUtil.cadenaX(filas[2]);
        catalogo.Descripcion = ClsUtil.cadenaX(filas[3]);
        catalogo.Unidad = ClsUtil.cadenaX(filas[4]);
        catalogo.Tipo = Number(filas[5]);
        catalogo.CostoMoneda1 = Number(filas[6]);
        catalogo.CostoMoneda2 = Number(filas[7]);
        catalogo.Expins = Number(filas[8]);
        catalogo.ImporteMoneda1 = ClsUtil.redondearMoneda(catalogo.CostoMoneda1 * catalogo.Expins, this.infPpto.decimalredondearimporte);
        // catalogo.ImporteMoneda1 = Number(filas[9]);
        catalogo.ImporteMoneda2 = ClsUtil.redondearMoneda(catalogo.CostoMoneda2 * catalogo.Expins, this.infPpto.decimalredondearimporte);
        // catalogo.ImporteMoneda2 = Number(filas[10]);
        catalogo.IdFamilia = ClsUtil.bigintX(filas[29]);
        catalogo.Familia = ClsUtil.cadenaX(filas[11]);
        catalogo.DescripcionFamilia = ClsUtil.cadenaX(filas[13]);
        catalogo.EsConceptosDelPpto = Boolean(Number(filas[12]));
        catalogo.IdProveedor = ClsUtil.bigintX(filas[30]);
        catalogo.Proveedor = ClsUtil.cadenaX(filas[14]);
        catalogo.RazonSocial = ClsUtil.cadenaX(filas[15]);
        catalogo.InsumoIntegrado = Boolean(Number(filas[16]));
        catalogo.FechaMoneda1 = ClsUtil.convertirAFechaReal(filas[17]);
        catalogo.FechaMoneda2 = ClsUtil.convertirAFechaReal(filas[18]);
        catalogo.EsCostoHorario = Boolean(Number(filas[19]));
        catalogo.PendienteAnalizar = Boolean(Number(filas[20]));
        catalogo.EsPorcentaje = Boolean(Number(filas[21]));
        catalogo.TipoPorcentaje = Number(filas[22]);
        catalogo.Nivel = Number(filas[23]);
        catalogo.ExpInsl = Boolean(Number(filas[24]));
        catalogo.Participa = Boolean(Number(filas[25]));
        catalogo.Marca = Boolean(Number(filas[26]));
        catalogo.Referencia = ClsUtil.cadenaX(filas[27]);
        catalogo.UrlContenido = ClsUtil.cadenaX(filas[28]);
        catalogo.ArrIdsMatriz = ClsUtil.toArrayBigIntX(filas[31]); // JSON.parse(filas[31]);
        catalogo.ArrIdsPartida = ClsUtil.toArrayBigIntX(filas[32]);
        catalogo.ObservacionPendiente = ClsUtil.cadenaX(filas[33]);
        catalogo.Url = catalogo.UrlContenido;
        catalogo.CantidadACopiar = '';
        catalogos.push(catalogo);
      });
      return catalogos;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public crearMenuContextual(esMaestro: boolean, esCH: boolean) {
    const subAsignar: INeodataMenu[] = [
      { id: EnumMCExpInsumos.AsignarFamilia, descripcion: 'MENUCONTEXTUAL.ASIGNAR_FAM', icono: 'group_add', disabled: esMaestro, divisor: false },
      { id: EnumMCExpInsumos.AsignarProveedor, descripcion: 'MENUCONTEXTUAL.ASIGNAR_PROV', icono: 'person_add', disabled: esMaestro, divisor: false },
      { id: EnumMCExpInsumos.AsignarTipoInsumos, descripcion: 'MENUCONTEXTUAL.ASIGNAR_TIPOINS', icono: '123', disabled: esMaestro, divisor: false },
      { id: EnumMCExpInsumos.AsignarUnidad, descripcion: 'MENUCONTEXTUAL.ASIGNAR_UNIDAD', icono: 'straighten', disabled: esMaestro, divisor: false },
    ];
    const subQuitar: INeodataMenu[] = [
      { id: EnumMCExpInsumos.QuitarFamilia, descripcion: 'MENUCONTEXTUAL.QUITAR_FAM', icono: 'group_remove', disabled: esMaestro, divisor: false },
      { id: EnumMCExpInsumos.QuitarProveedor, descripcion: 'MENUCONTEXTUAL.QUITAR_PROV', icono: 'person_remove', disabled: esMaestro, divisor: false },
    ];
    const subLayout: INeodataMenu[] = [
      { id: EnumMasOpciones.Ajustar, descripcion: 'MENUCONTEXTUAL.ALTO_FILA', icono: 'wrap_text', disabled: false, divisor: true },
      { id: EnumMCGenerales.GuardarLayout, descripcion: 'MENUCONTEXTUAL.GUARDAR_LAYOUT', icono: 'save', disabled: false, divisor: false },
      { id: EnumMCGenerales.ReestablecerLayout, descripcion: 'MENUCONTEXTUAL.RESTABLECER_LAYOUT', icono: 'restore', disabled: false, divisor: false }
    ];
    return this.menus = [
      { id: EnumMCExpInsumos.CambiarPropiedadesTipo, descripcion: 'MENUCONTEXTUAL.CAMBIAR_PROP', icono: '123', disabled: esMaestro, divisor: false },
      // { id: EnumMCExpInsumos.AsignarFamiliaIndices, descripcion: 'MENUCONTEXTUAL.ASIGNAR_FAM_INDICE', icono: '', disabled: esMaestro, divisor: true },
      // { id: EnumMCExpInsumos.QuitarFamiliaIndices, descripcion: 'MENUCONTEXTUAL.QUITAR_FAM_INDICE', icono: '', disabled: esMaestro, divisor: true },
      { id: EnumMCExpInsumos.Participa, descripcion: 'MENUCONTEXTUAL.PARTICIPA', icono: 'dynamic_feed', disabled: false, divisor: false },
      { id: EnumMCExpInsumos.Depurar, descripcion: 'MENUCONTEXTUAL.DEPURAR', icono: 'delete_forever', disabled: esMaestro, divisor: false  },
      // { id: EnumMCExpInsumos.UnificarCodigos, descripcion: 'MENUCONTEXTUAL.UNIFICAR', icono: '', disabled: esMaestro, divisor: false  },
      { id: EnumMCGenerales.Matriz, descripcion: 'MENUCONTEXTUAL.VER_MATRIZ', icono: 'folder', disabled: esCH, divisor: true },
      { id: EnumMCGenerales.CostoHorario, descripcion: 'MENUCONTEXTUAL.VER_COSTOHORARIO', icono: 'folder', disabled: !esCH, divisor: true },
      { id: '_asignar', descripcion: 'MENUCONTEXTUAL.ASIGNAR', icono: '', disabled: esMaestro, divisor: false, subMenu: subAsignar },
      { id: '_quitar', descripcion: 'MENUCONTEXTUAL.QUITAR', icono: '', disabled: esMaestro, divisor: true, subMenu: subQuitar },
      { id: EnumMCGenerales.MarcarTodo, descripcion: 'MENUCONTEXTUAL.MARCAR_TODO', icono: 'check_box', disabled: false, divisor: false  },
      { id: EnumMCGenerales.DesmarcarTodo, descripcion: 'MENUCONTEXTUAL.DESMARCAR_TODO', icono: 'remove_done', disabled: false, divisor: false  },
      // { id: EnumMCGenerales.SeleccionarTodo, descripcion: 'MENUCONTEXTUAL.SELECCIONAR_TODO', icono: 'check', disabled: esMaestro, divisor: false  },
      // { id: EnumMCGenerales.DeseleccionarTodo, descripcion: 'MENUCONTEXTUAL.DESELECCIONAR_TODO', icono: 'close', disabled: esMaestro, divisor: false  },
      // { id: EnumMCExpInsumos.MarcarSeleccionados, descripcion: 'MENUCONTEXTUAL.MARCAR_SELECCIONADOS', icono: '', disabled: esMaestro, divisor: false  },
      // { id: EnumMCExpInsumos.EnviarInsumosCotizar, descripcion: 'MENUCONTEXTUAL.ENVIAR_COTIZAR', icono: '', disabled: esMaestro, divisor: true  },
      // { id: EnumMCExpInsumos.ActualizarCostoInsumoCotizado, descripcion: 'MENUCONTEXTUAL.ACTUALIZAR_COSTOS', icono: '', disabled: esMaestro, divisor: false  },
      { id: EnumMCGenerales.Copiar, descripcion: 'MENUCONTEXTUAL.COPIAR', icono: 'content_copy', disabled: esMaestro, divisor: false },
      { id: EnumMCGenerales.Pegar, descripcion: 'MENUCONTEXTUAL.PEGAR', icono: 'content_paste', disabled: esMaestro, divisor: true },
      { id: '_layout', descripcion: 'MENUCONTEXTUAL.LAYOUT', icono: 'grid_on', disabled: false, divisor: true, subMenu: subLayout },
    ];
  }

  public crearMenuContextualExpInsAcoplado(esCH: boolean) {
    const subLayout: INeodataMenu[] = [
      { id: EnumMasOpciones.Ajustar, descripcion: 'MENUCONTEXTUAL.ALTO_FILA', icono: 'wrap_text', disabled: false, divisor: true },
      { id: EnumMCGenerales.GuardarLayout, descripcion: 'MENUCONTEXTUAL.GUARDAR_LAYOUT', icono: 'save', disabled: false, divisor: false },
      { id: EnumMCGenerales.ReestablecerLayout, descripcion: 'MENUCONTEXTUAL.RESTABLECER_LAYOUT', icono: 'restore', disabled: false, divisor: false }
    ];
    return this.menus = [
      // { id: EnumMCExpInsumos.CambiarPropiedadesTipo, descripcion: 'MENUCONTEXTUAL.CAMBIAR_PROP', icono: '123', disabled: esMaestro, divisor: true },
      // { id: EnumMCExpInsumos.AsignarFamiliaIndices, descripcion: 'MENUCONTEXTUAL.ASIGNAR_FAM_INDICE', icono: '', disabled: esMaestro, divisor: true },
      // { id: EnumMCExpInsumos.QuitarFamiliaIndices, descripcion: 'MENUCONTEXTUAL.QUITAR_FAM_INDICE', icono: '', disabled: esMaestro, divisor: true },
      { id: EnumMCExpInsumos.Participa, descripcion: 'MENUCONTEXTUAL.PARTICIPA', icono: 'dynamic_feed', disabled: false, divisor: false },
      // { id: EnumMCExpInsumos.Depurar, descripcion: 'MENUCONTEXTUAL.DEPURAR', icono: 'delete_forever', disabled: esMaestro, divisor: false  },
      // { id: EnumMCExpInsumos.UnificarCodigos, descripcion: 'MENUCONTEXTUAL.UNIFICAR', icono: '', disabled: esMaestro, divisor: false  },
      { id: EnumMCGenerales.Matriz, descripcion: 'MENUCONTEXTUAL.VER_MATRIZ', icono: 'folder', disabled: esCH, divisor: true  },
      { id: EnumMCGenerales.CostoHorario, descripcion: 'MENUCONTEXTUAL.VER_COSTOHORARIO', icono: 'folder', disabled: !esCH, divisor: true  },
      // { id: EnumMCExpInsumos.AsignarFamilia, descripcion: 'MENUCONTEXTUAL.ASIGNAR_FAM', icono: 'group_add', disabled: esMaestro, divisor: true },
      // { id: EnumMCExpInsumos.QuitarFamilia, descripcion: 'MENUCONTEXTUAL.QUITAR_FAM', icono: 'group_off', disabled: esMaestro, divisor: true },
      // { id: EnumMCExpInsumos.AsignarProveedor, descripcion: 'MENUCONTEXTUAL.ASIGNAR_PROV', icono: 'person_add', disabled: esMaestro, divisor: true },
      // { id: EnumMCExpInsumos.QuitarProveedor, descripcion: 'MENUCONTEXTUAL.QUITAR_PROV', icono: 'person_off', disabled: esMaestro, divisor: true },
      // { id: EnumMCGenerales.MarcarTodo, descripcion: 'MENUCONTEXTUAL.MARCAR_TODO', icono: 'check_box', disabled: false, divisor: false  },
      // { id: EnumMCGenerales.DesmarcarTodo, descripcion: 'MENUCONTEXTUAL.DESMARCAR_TODO', icono: 'remove_done', disabled: false, divisor: false  },
      // { id: EnumMCGenerales.SeleccionarTodo, descripcion: 'MENUCONTEXTUAL.SELECCIONAR_TODO', icono: 'check', disabled: esMaestro, divisor: false  },
      // { id: EnumMCGenerales.DeseleccionarTodo, descripcion: 'MENUCONTEXTUAL.DESELECCIONAR_TODO', icono: 'close', disabled: esMaestro, divisor: false  },
      // { id: EnumMCExpInsumos.MarcarSeleccionados, descripcion: 'MENUCONTEXTUAL.MARCAR_SELECCIONADOS', icono: '', disabled: esMaestro, divisor: false  },
      // { id: EnumMCExpInsumos.EnviarInsumosCotizar, descripcion: 'MENUCONTEXTUAL.ENVIAR_COTIZAR', icono: '', disabled: esMaestro, divisor: true  },
      // { id: EnumMCExpInsumos.ActualizarCostoInsumoCotizado, descripcion: 'MENUCONTEXTUAL.ACTUALIZAR_COSTOS', icono: '', disabled: esMaestro, divisor: false  },
      { id: EnumMCGenerales.Copiar, descripcion: 'MENUCONTEXTUAL.COPIAR', icono: 'content_copy', disabled: false, divisor: false  },
      // { id: EnumMCGenerales.Pegar, descripcion: 'MENUCONTEXTUAL.PEGAR', icono: 'content_paste', disabled: esMaestro, divisor: false  },
      { id: '_layout', descripcion: 'MENUCONTEXTUAL.LAYOUT', icono: 'grid_on', disabled: false, divisor: true, subMenu: subLayout },
    ];
  }

  public enterBusExpInsumos(buscar: string, buscarInicio: boolean) {
    try {
      this.gridExpInsumos.data.push(...this.gridDataCompleta);
      this.gridDataCompleta = [];
      this.gridDataFiltrada = [];

      buscar = ClsUtil.quitarAcentos(buscar.trim());
      if (buscar === '') {
        this.gridExpInsumos.data =  this.dataExpInsumo;
        return;
      }
      // Filtrar los datos
      this.gridExpInsumos.data = this.gridExpInsumos.data.filter((item: ClsCatalogosExpIns) => {
        if (ClsUtil.filtroGridMatchItem(item, ['Codigo', 'DescripcionLarga', 'Unidad', 'Familia', 'DescripcionFamilia', 'Proveedor', 'RazonSocial'], buscarInicio, buscar)) {
          this.gridDataFiltrada.push(item);
          return true;
        } else {
          this.gridDataCompleta.push(item);
          return false;
        }
      });
    } catch (e) {
      throw new Error(e.message);
    }
    return this.gridDataFiltrada;
  }

  public async agregarModificarListaExpInsumo(conceptoMatriz: ClsGuardarConceptosPartidaDetalle[] | ClsGuardarMatrizDetalle[], chkConsultarC: boolean, paramUnidades: ClsParametro[]): Promise<ClsCatalogosExpIns[]> {
    let hayNuevo = false;
    let eqNuevo = false;
    let EQs: ClsCatalogosExpIns[] = [];
    let objCatalogo: ClsCatalogosExpIns2[];
    let respuesta: any;
    const respExpInsModAdd: ClsCatalogosExpIns[] = [];
    conceptoMatriz.forEach((item: any) => {
      const cat: ClsCatalogosExpIns2 = item.Catalogo;
      const indexCodExiste: number = this.existeCodigoExpInsIndex(cat.Codigo);
      if (indexCodExiste !== -1) {
        const catOriginal: ClsCatalogosExpIns = this.infPpto.pptoActivoCompletoJSON.CatExpIns[indexCodExiste];
        if (!ClsUtil.esNulo(item.Marca)) {
          catOriginal.Marca = item.Marca;
        }
        catOriginal.Codigo = cat.Codigo;
        catOriginal.Participa = true;
        catOriginal.Descripcion = cat.Descripcion;
        catOriginal.DescripcionLarga = cat.DescripcionLarga;
        catOriginal.Tipo = cat.TipoInsumo;
        catOriginal.Unidad = cat.Unidad;
        catOriginal.CostoMoneda1 = cat.EsPorcentaje > 0 ? 1 : cat.CostoMoneda1;
        catOriginal.CostoMoneda2 = cat.EsPorcentaje > 0 ? 1 : cat.CostoMoneda2;
        catOriginal.EsCostoHorario = cat.EsCostoHorario;
        catOriginal.EsPorcentaje = Boolean(cat.EsPorcentaje);
        catOriginal.TipoPorcentaje = cat.EsPorcentaje;
        catOriginal.ArrIdsMatriz = cat.ArrIdsMatriz;
        catOriginal.ArrIdsPartida = cat.ArrIdsPartida;
        this.infPpto.pptoActivoCompletoJSON.CatExpIns[indexCodExiste] = catOriginal;
        respExpInsModAdd.push(catOriginal);
      } else {
        const catNuevo: ClsCatalogosExpIns = this.inicializarAsignarRegistro(undefined);
        catNuevo.IdCatalogo = item.IdCatalogo;
        if (!ClsUtil.esNulo(item.Marca)) {
          catNuevo.Marca = item.Marca;
        }
        catNuevo.Codigo = cat.Codigo;
        catNuevo.Descripcion = cat.Descripcion;
        catNuevo.DescripcionLarga = cat.DescripcionLarga;
        catNuevo.Tipo = cat.TipoInsumo;
        catNuevo.Unidad = cat.Unidad;
        catNuevo.CostoMoneda1 = cat.EsPorcentaje > 0 ? 1 : cat.CostoMoneda1;
        catNuevo.CostoMoneda2 = cat.EsPorcentaje > 0 ? 1 : cat.CostoMoneda2;
        catNuevo.EsCostoHorario = cat.EsCostoHorario;
        catNuevo.EsPorcentaje = Boolean(cat.EsPorcentaje);
        catNuevo.TipoPorcentaje = cat.EsPorcentaje;
        catNuevo.EsConceptosDelPpto = cat.EsConceptosDelPpto;
        catNuevo.Participa = true;
        catNuevo.FechaMoneda1 = cat.FechaMoneda1;
        catNuevo.FechaMoneda2 = cat.FechaMoneda2;
        catNuevo.IdFamilia = cat.IdFamilia;
        catNuevo.Familia = cat.Familia;
        catNuevo.IdProveedor = cat.IdProveedor;
        catNuevo.Proveedor = cat.Proveedor;
        catNuevo.UrlContenido = cat.UrlContenido;
        catNuevo.ArrIdsMatriz = cat.ArrIdsMatriz;
        catNuevo.ArrIdsPartida = cat.ArrIdsPartida;
        this.infPpto.pptoActivoCompletoJSON.CatExpIns.push(catNuevo);
        respExpInsModAdd.push(catNuevo);
        hayNuevo = true;
        // validamos que el codigo nuevo sea EQ(EsCostoHorario) para crear sus registros de
        // cargo fijo(CF), espera(-E), reserva(-R) y valor adquisición(VA)
        if (catNuevo.EsCostoHorario && hayNuevo) {
          EQs = EQs.concat(this.crearRegistrosEQ(catNuevo, paramUnidades));
          eqNuevo = true;
        }
      }
    });
    // si tenemos algun EQ
    if (eqNuevo) {
      // creamos OBJ para mandar al servicio
      objCatalogo = this.inicializarRegistroServicio(EQs, true);
      // mandamos peticion con el OBJ adecuado
      respuesta = await this.registraActualizaRegistro(objCatalogo);
      // iteramos la respuesta para ir asignando los idcat para los EQs
      const key: string[] = Object.keys(respuesta);
      key.forEach(value => {
        const EQAux: ClsCatalogosExpIns = EQs.find(value1 => value1.Codigo === value);
        EQAux.IdCatalogo = ClsUtil.bigintX(respuesta[value]);
        this.infPpto.pptoActivoCompletoJSON.CatExpIns.push(EQAux);
        respExpInsModAdd.push(EQAux);
      });
    }
    this.actualizarListaExpInsComponentes();
    return respExpInsModAdd;
  }

  public async agregarModificarListaExpInsumov2(conceptoMatriz: ClsGuardarConceptosPartidaDetalle[] | ClsGuardarMatrizDetalle[], chkConsultarC: boolean, paramUnidades: ClsParametro[]): Promise<ClsCatalogosExpIns[]> {
    const catExpIns = this.infPpto.pptoActivoCompletoJSON.CatExpIns;
    const mapPorCodigo = new Map<string, ClsCatalogosExpIns>();
    const respuesta: ClsCatalogosExpIns[] = [];
    const EQs: ClsCatalogosExpIns[] = [];

    let hayNuevo = false;

    // 1️⃣ Indexar catálogo existente
    for (let i = 0; i < catExpIns.length; i++) {
      mapPorCodigo.set(catExpIns[i].Codigo.toUpperCase(), catExpIns[i]);
    }

// 2️⃣ Procesar conceptos
    for (let i = 0; i < conceptoMatriz.length; i++) {
      const item: any = conceptoMatriz[i];
      const cat = item.Catalogo;
      const codigoKey = cat.Codigo.toUpperCase();

      let registro = mapPorCodigo.get(codigoKey);

      // 🔁 EXISTE → actualizar
      if (registro) {

        if (!ClsUtil.esNulo(item.Marca)) {
          registro.Marca = item.Marca;
        }

        registro.Codigo = cat.Codigo;
        registro.Participa = true;
        registro.Descripcion = cat.Descripcion;
        registro.DescripcionLarga = cat.DescripcionLarga;
        registro.Tipo = cat.TipoInsumo;
        registro.Unidad = cat.Unidad;
        registro.CostoMoneda1 = cat.EsPorcentaje > 0 ? 1 : cat.CostoMoneda1;
        registro.CostoMoneda2 = cat.EsPorcentaje > 0 ? 1 : cat.CostoMoneda2;
        registro.EsCostoHorario = cat.EsCostoHorario;
        registro.EsPorcentaje = Boolean(cat.EsPorcentaje);
        registro.TipoPorcentaje = cat.EsPorcentaje;
        registro.ArrIdsMatriz = cat.ArrIdsMatriz;
        registro.ArrIdsPartida = cat.ArrIdsPartida;

        respuesta.push(registro);

      } else {
        // 🆕 NUEVO
        registro = this.inicializarAsignarRegistro(undefined);

        registro.IdCatalogo = item.IdCatalogo;

        if (!ClsUtil.esNulo(item.Marca)) {
          registro.Marca = item.Marca;
        }

        registro.Codigo = cat.Codigo;
        registro.Descripcion = cat.Descripcion;
        registro.DescripcionLarga = cat.DescripcionLarga;
        registro.Tipo = cat.TipoInsumo;
        registro.Unidad = cat.Unidad;
        registro.CostoMoneda1 = cat.EsPorcentaje > 0 ? 1 : cat.CostoMoneda1;
        registro.CostoMoneda2 = cat.EsPorcentaje > 0 ? 1 : cat.CostoMoneda2;
        registro.EsCostoHorario = cat.EsCostoHorario;
        registro.EsPorcentaje = Boolean(cat.EsPorcentaje);
        registro.TipoPorcentaje = cat.EsPorcentaje;
        registro.EsConceptosDelPpto = cat.EsConceptosDelPpto;
        registro.Participa = true;
        registro.FechaMoneda1 = cat.FechaMoneda1;
        registro.FechaMoneda2 = cat.FechaMoneda2;
        registro.IdFamilia = cat.IdFamilia;
        registro.Familia = cat.Familia;
        registro.IdProveedor = cat.IdProveedor;
        registro.Proveedor = cat.Proveedor;
        registro.UrlContenido = cat.UrlContenido;
        registro.ArrIdsMatriz = cat.ArrIdsMatriz;
        registro.ArrIdsPartida = cat.ArrIdsPartida;

        catExpIns.push(registro);
        mapPorCodigo.set(codigoKey, registro);
        respuesta.push(registro);

        hayNuevo = true;

        // 🔥 Crear EQs solo si aplica
        if (registro.EsCostoHorario) {
          EQs.push(...this.crearRegistrosEQ(registro, paramUnidades));
        }
      }
    }
    // 3️⃣ Registrar EQs (si hubo)
    if (EQs.length) {
      // creamos OBJ para mandar al servicio
      const objCatalogo = this.inicializarRegistroServicio(EQs, true);
      // mandamos peticion con el OBJ adecuado
      const resp = await this.registraActualizaRegistro(objCatalogo);
      // iteramos la respuesta para ir asignando los idcat para los EQs
      const key: string[] = Object.keys(resp);
      key.forEach(codigo => {
        const eq = EQs.find(e => e.Codigo === codigo);
        if (eq) {
          eq.IdCatalogo = ClsUtil.bigintX(resp[codigo]);
          catExpIns.push(eq);
          respuesta.push(eq);
        }
      });
    }
    this.actualizarListaExpInsComponentes();
    return respuesta;
  }

  public agregarModificarBorrarListaExpIns(catalogo: ClsCatalogosExpIns[], borrar: boolean) {
    try {
      catalogo.forEach(registro => {
        const index: number = this.infPpto.pptoActivoCompletoJSON.CatExpIns.findIndex(insumo => ClsUtil.bigintX(insumo.IdCatalogo) === ClsUtil.bigintX(registro.IdCatalogo));
        if (borrar && index !== -1) {
          // Eliminar si existe y está marcado para borrar
          this.infPpto.pptoActivoCompletoJSON.CatExpIns.splice(index, 1);
        } else {
          // Si no existe, agregar; si existe, reemplazar
          if (index === -1) {
            this.infPpto.pptoActivoCompletoJSON.CatExpIns.push(registro);
          } else {
            this.infPpto.pptoActivoCompletoJSON.CatExpIns[index] = registro;
          }
        }
      });
      // Actualizar componentes relacionados
      this.actualizarListaExpInsComponentes();
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public actualizarListaExpInsComponentes() {
    let valBuscar: string;
    const dmSecundario: DmSecundarioComponent = this.infPpto.dmPrincipal.dmSecundarioPptoActivo;
    const datos: ClsCatalogosExpIns[] = ClsUtil.cambiarPptoActivoAMaestroExpInsumoAcoplado(this.infPpto.checkMaestroExpIns, this.infPpto);
    try {
      // exp ins ppto activo
      if (!ClsUtil.esNulo(dmSecundario.ExpInsumo)) {
        dmSecundario.ExpInsumo.ExpInsumoAcoplado.gridExpInsumos.data = this.infPpto.pptoActivoCompletoJSON.CatExpIns;
        dmSecundario.ExpInsumo.ExpInsumoAcoplado.gridExpInsumos.markForCheck();
        dmSecundario.ExpInsumo.ExpInsumoAcoplado.gridExpInsumos.cdr.detectChanges();
        // filtrar nuevamente si tiene valor
        valBuscar = dmSecundario.ExpInsumo.ExpInsumoAcoplado.filtroGeneral.input.value;
        if (ClsUtil.cadenaX(valBuscar).length > 0) {
          dmSecundario.ExpInsumo.ExpInsumoAcoplado.mObjExpInsumos.gridDataCompleta = [];
          dmSecundario.ExpInsumo.ExpInsumoAcoplado.onEnterBusExpInsumos(valBuscar);
        }
      }
      // exp ins acoplado matriz
      if (!ClsUtil.esNulo(dmSecundario.MActivo)) {
        dmSecundario.MActivo.ExpInsumoAcoplado.gridExpInsumos.data = datos;
        dmSecundario.MActivo.ExpInsumoAcoplado.dataExpInsumo = datos;
        dmSecundario.MActivo.ExpInsumoAcoplado.gridExpInsumos.markForCheck();
        dmSecundario.MActivo.ExpInsumoAcoplado.gridExpInsumos.cdr.detectChanges();
        // filtrar nuevamente si tiene valor
        valBuscar = dmSecundario.MActivo.ExpInsumoAcoplado.filtroGeneral.input.value;
        if (ClsUtil.cadenaX(valBuscar).length > 0) {
          dmSecundario.MActivo.ExpInsumoAcoplado.mObjExpInsumos.gridDataCompleta = [];
          dmSecundario.MActivo.ExpInsumoAcoplado.onEnterBusExpInsumos(valBuscar);
        }
      }
      // exp ins acoplado conceptos
      if (!ClsUtil.esNulo(dmSecundario.Ppto)) {
        dmSecundario.Ppto.ExpInsumoAcoplado.gridExpInsumos.data = datos;
        dmSecundario.Ppto.ExpInsumoAcoplado.dataExpInsumo = datos;
        dmSecundario.Ppto.ExpInsumoAcoplado.gridExpInsumos.markForCheck();
        dmSecundario.Ppto.ExpInsumoAcoplado.gridExpInsumos.cdr.detectChanges();
        // filtrar nuevamente si tiene valor
        valBuscar = dmSecundario.Ppto.ExpInsumoAcoplado.filtroGeneral.input.value;
        if (ClsUtil.cadenaX(valBuscar).length > 0) {
          dmSecundario.Ppto.ExpInsumoAcoplado.mObjExpInsumos.gridDataCompleta = [];
          dmSecundario.Ppto.ExpInsumoAcoplado.onEnterBusExpInsumos(valBuscar);
        }
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public cambiarDataExpInsAcoplado(chkValor: boolean) {
    try {
      // let valBuscar: string;
      const dmSecundario: DmSecundarioComponent = this.infPpto.dmPrincipal.dmSecundarioPptoActivo;
      const datos: ClsCatalogosExpIns[] = ClsUtil.cambiarPptoActivoAMaestroExpInsumoAcoplado(chkValor, this.infPpto);
      if (!ClsUtil.esNulo(dmSecundario)) {
        if (!ClsUtil.esNulo(dmSecundario.MActivo)) {
          dmSecundario.MActivo.ExpInsumoAcoplado.gridExpInsumos.data = datos;
          dmSecundario.MActivo.ExpInsumoAcoplado.dataExpInsumo = datos;
          dmSecundario.MActivo.ExpInsumoAcoplado.gridExpInsumos.markForCheck();
          dmSecundario.MActivo.ExpInsumoAcoplado.gridExpInsumos.cdr.detectChanges();
          // al cambiar de maestro a ppto o ppto a maestro limpiar filtro
          dmSecundario.MActivo.ExpInsumoAcoplado.gridExpInsumos.clearFilter();
          dmSecundario.MActivo.ExpInsumoAcoplado.clearInputExpInsumos();
          // filtrar nuevamente si tiene valor
          // valBuscar = dmSecundario.MActivo.ExpInsumoAcoplado.filtroGeneral.input.value;
          // if (ClsUtil.cadenaX(valBuscar).length > 0) {
          //   dmSecundario.MActivo.ExpInsumoAcoplado.mObjExpInsumos.gridDataCompleta = [];
          //   dmSecundario.MActivo.ExpInsumoAcoplado.onEnterBusExpInsumos(valBuscar);
          // }
        }
        if (!ClsUtil.esNulo(dmSecundario.Ppto)) {
          dmSecundario.Ppto.ExpInsumoAcoplado.gridExpInsumos.data = datos;
          dmSecundario.Ppto.ExpInsumoAcoplado.dataExpInsumo = datos;
          dmSecundario.Ppto.ExpInsumoAcoplado.gridExpInsumos.markForCheck();
          dmSecundario.Ppto.ExpInsumoAcoplado.gridExpInsumos.cdr.detectChanges();
          // al cambiar de maestro a ppto o ppto a maestro limpiar filtro
          dmSecundario.Ppto.ExpInsumoAcoplado.gridExpInsumos.clearFilter();
          dmSecundario.Ppto.ExpInsumoAcoplado.clearInputExpInsumos();
          // filtrar nuevamente si tiene valor
          // valBuscar = dmSecundario.Ppto.ExpInsumoAcoplado.filtroGeneral.input.value;
          // if (ClsUtil.cadenaX(valBuscar).length > 0) {
          //   dmSecundario.Ppto.ExpInsumoAcoplado.mObjExpInsumos.gridDataCompleta = [];
          //   dmSecundario.Ppto.ExpInsumoAcoplado.onEnterBusExpInsumos(valBuscar);
          // }
        }
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public getDataFiltrada(valor: string): any[] {
    let dataResultado: ClsCatalogosExpIns[] = this.dataExpInsumo;
    switch (valor) {
      case EnumExpInsumos.MTodos:
        return dataResultado;
      case EnumExpInsumos.MSoloExplosion:
        return dataResultado.filter((item: ClsCatalogosExpIns) => item.ExpInsl === true);
      case EnumExpInsumos.MConceptosPresupuesto:
        return dataResultado.filter((item: ClsCatalogosExpIns) => item.EsConceptosDelPpto === true);
      case EnumExpInsumos.MBasicos:
        return dataResultado.filter((item: ClsCatalogosExpIns) => item.Nivel > 0 && item.EsConceptosDelPpto === false && item.EsCostoHorario === false);
        case EnumExpInsumos.MSoloMarcados:
          dataResultado = [];
          this.gridExpInsumos.selectedRows.forEach(value => {
            const rowData = this.gridExpInsumos.getRowData(value);
            dataResultado.push(rowData);
          });
          return dataResultado;
      default:
        return [];
    }
  }

  public validarCrearObjCatalogos(data: ClsCatalogosExpIns[], cat: any, allColumnas: string[], objGenerico: ClsObjGenerico): ClsCatalogosExpIns {
    let obj: ClsCatalogosExpIns;
    try {
      const regCatDef: ClsCatalogosExpIns = this.inicializarAsignarRegistro(undefined);
      const valTipo: any = cat[allColumnas[5]];
      const valCod: string = (cat[allColumnas[1]] as string).toUpperCase();
      // // validar longitudes
      // ClsUtil.validarDataMax(valCod, 20, objGenerico, allColumnas[1]);
      // if (!ClsUtil.esNulo(valTipo)) {
      //   const tipo: number = Number(valTipo);
      //   if (tipo <= 0) {
      //     throw new Error('MENSAJES.ALERT.TIPO_INSUMO_NO_VALIDO');
      //   }
      // }
      // buscamos el codigo en el pull de registros
      obj = data.find(value => value.Codigo === valCod);
      if (ClsUtil.esNulo(obj)) {
        const obj2: any = this.reemplazarInfCatalogo(regCatDef, cat, allColumnas, objGenerico);
        obj = obj2.registro;
      } else {
        const obj2: any = this.reemplazarInfCatalogo(obj, cat, allColumnas, objGenerico);
        // si no cambia nada, regresamos undefined para no modificar nada el pull de registros
        obj = obj2.cambio ? obj2.registro : undefined;
      }
    } catch (e) {
      throw new Error(e.message);
    }

    return obj;
  }

  public reemplazarInfCatalogo(registro: ClsCatalogosExpIns, cat: any, allColumnas: string[], objGenerico: ClsObjGenerico): any {
    const fecha = new Date();
    let cambio = false;
    const valMarca: any = cat[allColumnas[0]];
    const valCod: string = (cat[allColumnas[1]] as string).toUpperCase();
    const valDes: string = cat[allColumnas[2]];
    const valDesCom: string = cat[allColumnas[3]];
    const valUni: string = cat[allColumnas[4]];
    const valTipo: any = cat[allColumnas[5]];
    const valC1: any = cat[allColumnas[6]];
    const valC2: any = cat[allColumnas[7]];
    const valFam: string = cat[allColumnas[8]];
    const valProv: string = cat[allColumnas[9]];
    const valInsInt: any = cat[allColumnas[10]];
    const valF1: any = cat[allColumnas[11]];
    const valF2: any = cat[allColumnas[12]];
    const valEsCH: any = cat[allColumnas[13]];
    const valEsPorc: any = cat[allColumnas[14]];
    const valTipoPorc: any = cat[allColumnas[15]];
    const valRef: string = cat[allColumnas[16]];
    const valUrlCont: string = cat[allColumnas[17]];
    let ch: boolean;
    let tipoPorc: number;
    try {
      if (!ClsUtil.esNulo(valMarca)) {
        const marca: boolean = valMarca === '1';
        if (marca !== registro.Marca) {
          registro.Marca = marca;
          cambio = true;
        }
      }
      if (valCod !== registro.Codigo) {
        registro.Codigo = valCod;
        cambio = true;
      }
      if (!ClsUtil.esNulo(valDes) && !ClsUtil.esNulo(valDesCom)) {
        if (valDesCom !== registro.DescripcionLarga) {
          registro.DescripcionLarga = valDesCom;
          cambio = true;
        }
        if (valDes !== registro.Descripcion) {
          registro.Descripcion = valDes.substring(0, 40);
          cambio = true;
        }
      } else if (!ClsUtil.esNulo(valDes)) {
        if (valDes !== registro.Descripcion) {
          registro.Descripcion = valDes.substring(0, 40);
          cambio = true;
        }
        if (valDes !== registro.DescripcionLarga) {
          registro.DescripcionLarga = valDes;
          cambio = true;
        }
      } else if (!ClsUtil.esNulo(valDesCom)) {
        if (valDesCom !== registro.Descripcion) {
          registro.Descripcion = valDesCom.substring(0, 40);
          cambio = true;
        }
        if (valDesCom !== registro.DescripcionLarga) {
          registro.DescripcionLarga = valDesCom;
          cambio = true;
        }
      }
      if (!ClsUtil.esNulo(valUni)) {
        if (valUni !== registro.Unidad) {
          registro.Unidad = valUni.toUpperCase();
          cambio = true;
        }
      }
      if (!ClsUtil.esNulo(valTipo)) {
        const tipo: number = Number(valTipo);
        if (tipo !== registro.Tipo) {
          registro.Tipo = tipo;
          cambio = true;
        }
      }
      if (!ClsUtil.esNulo(valC1)) {
        const m1: number = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(ClsUtil.currencyToNumberFormat(valC1), this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
        if (m1 !== registro.CostoMoneda1) {
          if (registro.Nivel === 0 && !registro.EsPorcentaje && !registro.EsCostoHorario) {
            registro.CostoMoneda1 = m1;
            registro.FechaMoneda1 = new Date(fecha.getUTCFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours(), fecha.getMinutes(), fecha.getSeconds(), fecha.getMilliseconds());
            cambio = true;
          }
        }
      }
      if (!ClsUtil.esNulo(valC2)) {
        const m2: number = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(ClsUtil.currencyToNumberFormat(valC2), this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
        if (m2 !== registro.CostoMoneda2) {
          if (registro.Nivel === 0 && !registro.EsPorcentaje && !registro.EsCostoHorario) {
            registro.CostoMoneda2 = m2;
            registro.FechaMoneda2 = new Date(fecha.getUTCFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours(), fecha.getMinutes(), fecha.getSeconds(), fecha.getMilliseconds());
            cambio = true;
          }
        }
      }
      if (!ClsUtil.esNulo(valFam)) {
        if (valFam !== registro.Familia) {
          registro.Familia = valFam.toUpperCase();
          cambio = true;
        }
      }
      if (!ClsUtil.esNulo(valProv)) {
        if (valProv !== registro.Proveedor) {
          registro.Proveedor = valProv.toUpperCase();
          cambio = true;
        }
      }
      if (!ClsUtil.esNulo(valEsCH)) {
        ch = valEsCH === '1';
        if (ch !== registro.EsCostoHorario) {
          registro.EsCostoHorario = ch;
          cambio = true;
        }
      }
      if (!ClsUtil.esNulo(valTipoPorc) && !ch) {
        tipoPorc = Number(valTipoPorc);
        if (tipoPorc !== registro.TipoPorcentaje) {
          registro.TipoPorcentaje = tipoPorc;
          cambio = true;
        }
        if (tipoPorc !== 0) {
          if (!ClsUtil.esNulo(valEsPorc)) {
            const esPorc = true;
            if (esPorc !== registro.EsPorcentaje) {
              registro.EsPorcentaje = esPorc;
              cambio = true;
            }
          }
        }
      }
      // se actualiza Ins Int siempre y cuando no sea %
      if (tipoPorc === 0) {
        if (!ClsUtil.esNulo(valInsInt)) {
          const insInt: boolean = valInsInt === '1';
          if (insInt !== registro.InsumoIntegrado) {
            registro.InsumoIntegrado = insInt;
            cambio = true;
          }
        }
      }
      if (!ClsUtil.esNulo(valRef)) {
        if (valRef !== registro.Referencia) {
          registro.Referencia = valRef.substring(0, 20);
          cambio = true;
        }
      }
      if (!ClsUtil.esNulo(valUrlCont)) {
        if (valUrlCont !== registro.UrlContenido) {
          registro.UrlContenido = valUrlCont.substring(0, 350);
          registro.Url = registro.UrlContenido;
          cambio = true;
        }
      }
    } catch (e) {
      throw new Error(e.message);
    }
    return { registro, cambio };
  }

  public generarMensajeBorrado(regBorrar: ClsBorrarRegistro[], objGenerico: ClsObjGenerico): string {
    let mensaje = '';
    let msjCHMCon = '';
    let msjPCon = '';
    let msjP: string = objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_P_CAT');
    let msjCHM: string = objGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CH_M_CAT');
    const arrayTMCH: ClsBorrarRegistro[] = regBorrar.filter(value => value.TieneMatriz === true || value.TieneCH === true);
    const arrayP: ClsBorrarRegistro[] = regBorrar.filter(value => value.Participa === true);
    arrayP.forEach(value => {
      if (msjPCon.length > 0) {
        msjPCon += '\n';
      }
      msjPCon += value.Codigo;
    });
    if (msjPCon.length > 0) {
      msjP = msjP.replace('{0}', msjPCon);
      mensaje = msjP;
    }
    arrayTMCH.forEach(value => {
      if (msjCHMCon.length > 0) {
        msjCHMCon += '\n';
      }
      msjCHMCon += value.Codigo;
    });
    if (msjCHMCon.length > 0) {
      msjCHM = msjCHM.replace('{0}', msjCHMCon);
      mensaje = msjPCon.length > 0 ? mensaje + '\n' + msjCHM : msjCHM;
    }
    return mensaje;
  }

  public async abrirExpInsXConceptos(dataFila: any) {
    try {
      const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
      vtnGenerico.verIconoMaxMin = true;
      vtnGenerico.queVtnEstaAbierta = 'ExpInsXConceptos';
      const vtnExpInsumosPorConcepto = vtnGenerico.crearComponente(ExpInsumosPorConceptoComponent);
      vtnExpInsumosPorConcepto.filaSeleccionada = dataFila;
      await vtnExpInsumosPorConcepto.open();
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public actualizarFechasReales(data: ClsCatalogosExpIns[]): ClsCatalogosExpIns[] {
    const exp: ClsCatalogosExpIns[] = [];
    data.forEach(value => {
      value.FechaMoneda1 = ClsUtil.convertirAFechaReal(value.FechaMoneda1);
      value.FechaMoneda2 = ClsUtil.convertirAFechaReal(value.FechaMoneda2);
      exp.push(this.inicializarAsignarRegistro(value));
    });
    return exp;
  }

  //#region Traduccion
  public getTranslationsQuestionAplicarFactor(registros: number): string {
    return ClsUtil.getTranslations(['MENSAJES.QUESTION.APLICAR_FACTOR'], this.infApp)['MENSAJES.QUESTION.APLICAR_FACTOR'].toString().replace('{0}', registros);
  }

  public getTranslationsAlertResultadoFactor(numOriginal: number, numAfectados: number): string {
    return ClsUtil.getTranslations(['MENSAJES.ALERT.EXP_INS_NUMERO_AFECTADOS_FACTOR'], this.infApp)['MENSAJES.ALERT.EXP_INS_NUMERO_AFECTADOS_FACTOR'].toString().replace('{0}', numAfectados).replace('{1}', numOriginal);
  }

  public getTranslationsAlertValidarCampos(campo: string, codigo: string): string {
    return ClsUtil.getTranslations(['MENSAJES.ALERT.CODIGO_NO_PUEDE_SER_MISMO'], this.infApp)['MENSAJES.ALERT.CODIGO_NO_PUEDE_SER_MISMO'].toString().replace('{0}', campo).replace('{1}', codigo);
  }

  public getTranslationsAwaitRegistrosCopiando(mensajeTrans: string, cuantos: number, codigo: string): string {
    return ClsUtil.getTranslations([mensajeTrans], this.infApp)[mensajeTrans].toString().replace('{0}', cuantos).replace('{1}', codigo);
  }
  //#endregion
}
